import React, { DOMAttributes } from 'react';
import styled from 'styled-components';

interface Props {
  icon: JSX.Element;
  onClick: DOMAttributes<HTMLDivElement>['onClick'];
  setEnableBlur: (enableBlur: boolean) => void;
}

export default function RightActionIcon({ icon, onClick, setEnableBlur }: Props) {
  return (
    <InputRightActionIconContainer
      data-testid="qa-input-right-icon"
      className="qa-input-right-icon"
      onClick={onClick}
      onMouseEnter={() => setEnableBlur(false)}
      onMouseLeave={() => setEnableBlur(true)}>
      <RightActionIconWrapper className="rightIcon">{icon}</RightActionIconWrapper>
    </InputRightActionIconContainer>
  );
}

const RightActionIconWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
RightActionIconWrapper.displayName = 'RightActionIconWrapper';

const InputRightActionIconContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
  width: 4rem;
  z-index: 2;
`;
InputRightActionIconContainer.displayName = 'InputRightActionIconContainer';
